import React from 'react'
import styled from 'styled-components'

const PlusDialog = styled.div.attrs(() => ({
  id: 'plusDialog',
}))`
  clear: both;
  margin-bottom: ${(props) => props.theme.mobile.sizes.gapVertical};
  scroll-margin: 50px;

  @media (min-width: ${(props) => props.theme.mobile.breakPoint + 'px'}) {
    top: calc(${(props) => props.theme.mobile.sizes.gapVertical} + 250px);
  }
`

export default PlusDialog
